//Generated File 
export default class UserFeedback{
	static readonly Dislike = `Dislike`;
	static readonly Like = `Like`;
}
